module.exports = __webpack_public_path__ + "static/media/accessory_04.dde8dc46.jpg";